// @flow

import { MonIdentite } from '../../network/api/types/compte/MonIdentite';
import { reduce } from '../reduce';

export type InitialStateType = {
  myIdentity: MonIdentite,
};

const initialState: InitialStateType = {
  myIdentity: null,
};

export const SAVE_DYNAMIC_KEYS_LIST = 'UPDATE_MY_IDENTITY';

const userReducer = reduce(initialState, {
  [SAVE_DYNAMIC_KEYS_LIST]: 'myIdentity',
});

export default userReducer;
